<template>
  <div class="w-full flex items-center justify-center h-screen">
    <div class="pt-4 container text-center flex flex-col items-center">
      <img class="w-40 h-10" :src="image || logo" />
      <div class="flex flex-col gap-4 justify-center items-center max-w-[360px] w-full mt-5">
        <SuccessIcon />
        <div>
          <h1 class="h1 text-grey-light-900 font-semibold text-xl">Your email has been successfully verified!</h1>
          <p class="font-normal text-black">Use the button below to go the dashboard.</p>
        </div>
        <button
          class="bg-brand-600 rounded w-full h-10 text-base-white hover:bg-brand-700 disabled:opacity-50 disabled:bg-brand-600"
          @click="goToSignIn()"
          data-testid="go_to_dashboard"
        >
          Go To Dashboard
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LogoImage from '@/assets/logo.svg';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import { useUserStore } from '@/stores/users';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const userStore = useUserStore();

defineProps<{
  image?: string;
}>();

const logo = computed(() => {
  return LogoImage;
});

const goToSignIn = async () => {
  await userStore.signOut();
  router.push({ name: 'merchantSignIn' });
};
</script>
